import { useEffect, useState } from 'react'

function formatTimeLeft(secondsLeft: number): string {
  const minutes = Math.floor(secondsLeft / 60)
  const seconds = secondsLeft % 60

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** A one-shot countdown for the paywall's limited-offer bar. */
export default function useCountdown(minutes: number) {
  const [secondsLeft, setSecondsLeft] = useState(minutes * 60)

  useEffect(() => {
    const interval = setInterval(
      () => setSecondsLeft((current) => Math.max(current - 1, 0)),
      1000,
    )

    return () => clearInterval(interval)
  }, [])

  return { isExpired: secondsLeft === 0, timeLeft: formatTimeLeft(secondsLeft) }
}
